export var HTLCStatus;
(function (HTLCStatus) {
    HTLCStatus["Initial"] = "initial";
    HTLCStatus["UserLocked"] = "userLocked";
    HTLCStatus["SolverLockDetected"] = "solverLockDetected";
    HTLCStatus["SecretRevealed"] = "secretRevealed";
    HTLCStatus["ManualClaimRequired"] = "manualClaimRequired";
    HTLCStatus["RedeemCompleted"] = "redeemCompleted";
    HTLCStatus["TimelockExpired"] = "timelockExpired";
    HTLCStatus["Refunded"] = "refunded";
})(HTLCStatus || (HTLCStatus = {}));
export const TERMINAL_STATUSES = new Set([
    HTLCStatus.RedeemCompleted,
    HTLCStatus.Refunded,
]);
export function isTerminalStatus(status) {
    return !!status && TERMINAL_STATUSES.has(status);
}
